import React, { useEffect } from 'react';
import '../styles/ImpactNumbers.css';

function OurValues() {
  useEffect(() => {
    const titleElement = document.querySelector('.impact-title');
    if (titleElement) {
      titleElement.classList.add('animate-in');
    }
  }, []);

  return (
    <section className="impact-section1">
        <h2 className="impact-title">
        <span className="impact-numbers">Our </span>Values
      </h2>
      <div className="impact-image-container">
        <img 
          src="/assets/images/ourvalues.png" 
          alt="Biking impact" 
          className="impact-background-image" 
        />
      </div>
    </section>
  );
}

export default OurValues;